import { render, staticRenderFns } from "./DailyChallengeSolutions.vue?vue&type=template&id=1ec6ba4e&scoped=true&"
import script from "./DailyChallengeSolutions.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeSolutions.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeSolutions.vue?vue&type=style&index=0&id=1ec6ba4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6ba4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ec6ba4e', component.options)
    } else {
      api.reload('1ec6ba4e', component.options)
    }
    module.hot.accept("./DailyChallengeSolutions.vue?vue&type=template&id=1ec6ba4e&scoped=true&", function () {
      api.rerender('1ec6ba4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeSolutions.vue"
export default component.exports